export class ReportDamage {
  public damagedescription: string;
  public damagecause: string;
  public bookingHashId: string;
  public vehicleHashId: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/models/reportdamage.model.ts